import { call, put } from 'redux-saga/effects'
import { NdlDeploymentsActions } from '../reducers/NdlDeploymentsRedux'

export const findNdlDeployments = function* (api, { payload }) {
  try {
    const query = (payload && payload.query) || payload || {}
    const response = yield call(api.create, '/ndl/deployments/filter', query)

    yield put(NdlDeploymentsActions.findSuccess(response))
  } catch (err) {
    console.log(err)
    yield put(NdlDeploymentsActions.findFailure(err.message))
  }
}
